"use strict";

angular.module("preciseCurrency", []);

require("./precise-currency.filter.js");



//////////////////
// WEBPACK FOOTER
// ./core/precise-currency/precise-currency.module.js
// module id = 318
// module chunks = 0